import { Button, Modal, Alert } from "antd";
import api from "ApiClient";
import { isEmpty } from "lodash";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ApiURL } from "utils/Actions";
import { API_RESPONSE_STATUS } from "utils/Constants";
interface DeleteAccountModalProps {
  open: boolean;
  onCancel: () => void;
}
export default function DeleteAccountModal({ open, onCancel }: DeleteAccountModalProps) {
  const history = useHistory();
  const { t } = useTranslation();
  const [isDeleting, setIsDeleting] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);

  const logOut = useCallback(() => {
    history.push("/", { disableTimeoutPrompt: true });
  }, []);

  const handleDelete = useCallback(async () => {
    setIsDeleting(true);
    try {
      const result = await api.delete(ApiURL.deleteAccount);
      if (result.data.status === API_RESPONSE_STATUS.SUCCESS) {
        logOut();
      } else {
        setErrors(result.data.errors);
      }
    } catch (error) {
      setErrors(["An error occurred while sending the request. Please try again."]);
      console.error(error);
    } finally {
      setIsDeleting(false);
    }
  }, []);

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={t("myAccount.deleteAccount.confirmModal.title")}
      closable={!isDeleting}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={isDeleting}>
          {t("myAccount.deleteAccount.confirmModal.cancelCTA")}
        </Button>,
        <Button
          key="delete"
          type="primary"
          danger
          onClick={handleDelete}
          disabled={isDeleting}
          loading={isDeleting}
        >
          {t("myAccount.deleteAccount.confirmModal.deleteCTA")}
        </Button>
      ]}
    >
      {!isEmpty(errors) && (
        <Alert
          message={errors.join(" ")}
          type="error"
          closable={false}
          showIcon
          style={{ width: "100%", marginBottom: 24 }}
        />
      )}
      <div>{t("myAccount.deleteAccount.confirmModal.msg")}</div>
    </Modal>
  );
}
